// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Control from "../../grpc/Control.js";
import * as Buhta_cabinet__PageNav from "../../components/molecules/PageNav.js";
import * as Buhta_cabinet__Search from "../../components/molecules/Search/Search.js";
import * as Buhta_cabinet__Table2 from "../../components/molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../util/Timestamp.js";
import * as Buhta_components__CopyButton from "../../../../../packages/components/src/CopyButton.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function OrgsPage(Props) {
  const match = React.useState(function () {
        return 1;
      });
  const setPage = match[1];
  const page = match[0];
  const match$1 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Control.OrgService.grid, undefined);
  const grid = match$1[0];
  const currentRecords = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
  const rows = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */0 : Stdlib__List.mapi((function (i, model) {
            const chief = model.chief;
            const chief$1 = chief !== undefined ? chief : ({
                  id: "",
                  tin: "",
                  resident: false,
                  position: "",
                  family_name: "",
                  given_name: "",
                  patronymic_name: "",
                  create_time: undefined,
                  update_time: undefined
                });
            const cells_0 = {
              body: JsxRuntime.jsxs("div", {
                    children: [
                      String(model.id),
                      JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                            text: String(model.id)
                          })
                    ],
                    className: "flex items-center gap-1"
                  }),
              style: ""
            };
            const cells_1 = {
              hd: {
                body: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: model.name,
                                      className: "max-w-[250px] overflow-hidden text-ellipsis whitespace-nowrap truncate",
                                      title: model.name
                                    }),
                                JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                                      text: model.name
                                    })
                              ],
                              className: "flex items-center gap-1"
                            }),
                        JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                              className: "text-gray-medium flex items-center gap-1 truncate",
                              children: [
                                model.name[0] === "ИП"[0] ? "ИИН: " : "БИН: ",
                                model.tin,
                                JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                                      text: model.tin,
                                      small: true
                                    })
                              ]
                            })
                      ],
                      className: "flex flex-col gap-1"
                    }),
                style: "col-span-2"
              },
              tl: {
                hd: {
                  body: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                        className: "flex items-center gap-1",
                        children: [
                          chief$1.given_name + (" " + chief$1.family_name),
                          JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                                text: chief$1.given_name + (" " + chief$1.family_name)
                              })
                        ]
                      }),
                  style: "col-span-2"
                },
                tl: {
                  hd: {
                    body: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                className: "flex items-center gap-1 text-gray-medium",
                                children: [
                                  "Не указано",
                                  JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                                        text: "Не указано"
                                      })
                                ]
                              }),
                          className: "flex"
                        }),
                    style: ""
                  },
                  tl: {
                    hd: {
                      body: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                  className: "flex items-center gap-1 text-gray-medium",
                                  children: [
                                    "Не указано",
                                    JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                                          text: "Не указано"
                                        })
                                  ]
                                }),
                            className: "flex"
                          }),
                      style: "col-span-2"
                    },
                    tl: {
                      hd: {
                        body: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              children: DateTime.toDateFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(model.create_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))))
                            }),
                        style: "justify-end"
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            };
            const cells = {
              hd: cells_0,
              tl: cells_1
            };
            const Key = String(i);
            return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
                        cells: cells,
                        route: {
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Orgs */1,
                            _0: /* Org */{
                              _0: model.id,
                              _1: /* Dashboard */0
                            }
                          }
                        }
                      }, Key);
          }), grid.VAL);
  return JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsx(Buhta_cabinet__Search.make, {
                      dispatch: match$1[1],
                      page: page,
                      setPage: setPage,
                      searchLength: 1,
                      expand: {
                        hd: "bank_account",
                        tl: {
                          hd: "chief",
                          tl: /* [] */0
                        }
                      },
                      showFilter: true
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                            header: {
                              hd: {
                                name: "#",
                                style: "col-span-1"
                              },
                              tl: {
                                hd: {
                                  name: "Наименование",
                                  style: "col-span-2"
                                },
                                tl: {
                                  hd: {
                                    name: "Руководитель",
                                    style: "col-span-2"
                                  },
                                  tl: {
                                    hd: {
                                      name: "Номер телефона",
                                      style: ""
                                    },
                                    tl: {
                                      hd: {
                                        name: "Почта",
                                        style: "col-span-2"
                                      },
                                      tl: {
                                        hd: {
                                          name: "Дата создания",
                                          style: "text-right"
                                        },
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            },
                            rows: rows,
                            styles: "flex-1 grid-cols-9 auto-rows-min"
                          }),
                      className: "flex-1 overflow-auto"
                    }),
                JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                      page: page,
                      setPage: setPage,
                      currentRecords: currentRecords
                    })
              ]
            });
}

const make = OrgsPage;

export {
  make ,
}
/* Buhta_cabinet__Control Not a pure module */
